module.exports = __webpack_public_path__ + "img/087b6bfa4ed9fce52fd22273573394fe.png";